import React, { useEffect, useState } from "react";
import "./EditItemBill.css";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import {
  getAllItemsBill,
  updateItemBill,
} from "../../redux/apiCalls/itemsCall/itemBills";
import { Toast } from "../../helpers/alert";
import { FormattedMessage } from "react-intl";

const EditItemBill = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.user.currentUser);
  const supplier = useSelector((state) => state.supplier.supplier);
  const allItems = useSelector((state) => state.itemsBill.itemsBill);
  const currentItem = allItems.find((item) => item.id === Number(id));
  const [modifiedFields, setModifiedFields] = useState({});
  const [units, setUnits] = useState([]);
  const [inputs, setInputs] = useState({
    lineItemText: currentItem?.lineItemText || "",
    proveedor: currentItem?.proveedor.toUpperCase() || "",
    class: currentItem?.class || "",
    unit: currentItem?.unit || "",
    costUnit: currentItem?.costUnit || "",
    consumptionUnit: currentItem?.consumptionUnit || "",
  });
  const [errors, setErrors] = useState({
    lineItemText: "",
    proveedor: "",
    class: "",
  });

  let sortedSuppliers = supplier
    ? [...supplier].sort((a, b) => a.nombre.localeCompare(b.nombre))
    : [];

  useEffect(() => {
    if (user.privilege === "editor" || user.privilege === "master") {
      getAllItemsBill(dispatch, user?.accessToken, "");
    }
  }, [dispatch, user]);

  useEffect(() => {
    const uniqueUnits = [
      ...new Set(
        (allItems || [])
          .map((item) => item.consumptionUnit)
          // saco null y "null"
          .filter((unit) => unit !== null && unit !== "null")
          // normalizo strings: trim para sacar espacios
          .map((unit) => (typeof unit === "string" ? unit.trim() : unit))
          // saco vacíos y falsy: "", null, undefined
          .filter((unit) => unit)
      ),
    ].sort((a, b) => a.localeCompare(b));

    setUnits(uniqueUnits);
  }, [allItems]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setInputs((prevInputs) => ({
      ...prevInputs,
      [name]: value,
    }));

    setModifiedFields((prevFields) => ({
      ...prevFields,
      [name]: true,
    }));

    validateField(name, value);
  };

  const validateField = (name, value) => {
    switch (name) {
      case "lineItemText":
        setErrors((prevErrors) => ({
          ...prevErrors,
          lineItemText: value.trim() === "" ? "Campo requerido" : "",
        }));
        break;
      case "proveedor":
        setErrors((prevErrors) => ({
          ...prevErrors,
          proveedor: value === "" ? "Selecciona un proveedor" : "",
        }));
        break;
      case "class":
        setErrors((prevErrors) => ({
          ...prevErrors,
          class: value.trim() === "" ? "Campo requerido" : "",
        }));
        break;
      default:
        break;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const modifiedData = {};

    for (const key in modifiedFields) {
      if (modifiedFields[key]) {
        modifiedData[key] = inputs[key];
      }
    }

    const keys = Object.keys(modifiedData);
    const isValidKeys =
      keys.length <= 2 &&
      keys.every((key) => ["consumptionUnit", "proveedor"].includes(key));

    const isConsumptionUnitNull = modifiedData["consumptionUnit"] === "null";
    const isValid = isValidKeys && isConsumptionUnitNull;

    Swal.fire({
      title: "¿Está seguro que desea editar el concepto?",
      text: isValid
        ? "ATENCIÓN: En caso que SOLO hayas modificado la unidad de consumo a 'No corresponde consumo' esto editará dicho concepto de todas las facturas asociadas a este proveedor. Les eliminará el consumo y les cambiará la unidad. Su usuario quedará registrado."
        : "",
      icon: "info",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, editar",
      cancelButtonText: "Cancelar",
      input: "checkbox",
      inputValue: 0,
      inputPlaceholder: "Entiendo y quiero confirmar la modificación.",
      inputValidator: (result) => {
        return !result && "Debes confirmar tildando la casilla para proceder";
      },
    }).then((result) => {
      if (result.isConfirmed && result.value) {
        const finalModifiedData = {
          ...modifiedData,
          consumptionUnit:
            modifiedData.consumptionUnit === "null"
              ? null
              : modifiedData.consumptionUnit,
        };
        const dataItem = {
          modifiedData: finalModifiedData,
          info: {
            ...inputs,
            consumptionUnit:
              inputs.consumptionUnit === "null" ? null : inputs.consumptionUnit,
            oldConsumptionUnit: currentItem?.consumptionUnit,
          },
          username: user?.user,
        };

        updateItemBill(dispatch, id, dataItem, user.accessToken).then((res) => {
          if (res?.error) {
            Toast.fire({
              icon: "error",
              title: res?.message,
            });
          } else {
            navigate(`/ebm/suppliers?show=lineitem`);
          }
        });
      } else {
        Toast.fire({
          icon: "info",
          title: `No se pudo editar el concepto.`,
        });
      }
    });
  };

  return (
    <div>
      <div className="cont-path">
        <p className="path path-cursor" onClick={() => navigate("/")}>
          Dashboard {">"}
        </p>
        <p className="path path-cursor" onClick={() => navigate("/ebm/suppliers?show=lineitem")}>
          Lista de proveedores {">"}
        </p>
        <p className="path">
          <FormattedMessage id="EditItems" defaultMessage="Editar concepto" />
        </p>
      </div>
      <div className="editItem-cont-profileinfo">
        <div className="editItem-list-group">
          <p>Editar concepto</p>

          <div className="editItem-ind-info">
            <label htmlFor="lineItemText">Concepto:</label>
            <li className="editItem-list-group-item">
              <input
                type="text"
                id="lineItemText"
                name="lineItemText"
                placeholder={currentItem?.lineItemText}
                value={inputs.lineItemText}
                onChange={handleInputChange}
                className="editItem-input_text"
              />
            </li>
            <span className="editItem-error-message">
              {errors.lineItemText}
            </span>
          </div>
          <div className="editItem-ind-info">
            <label htmlFor="proveedor">Proveedor:</label>
            <li className="editItem-list-group-item">
              <select
                id="proveedor"
                name="proveedor"
                value={inputs.proveedor}
                onChange={handleInputChange}
                className="editItem-input_text"
              >
                {sortedSuppliers &&
                  sortedSuppliers.map((s) => (
                    <option value={s.nombre.toUpperCase()} key={s.id}>
                      {s.nombre}
                    </option>
                  ))}
                <option value={inputs.proveedor} key="customSupplier">
                  {inputs.proveedor}
                </option>
              </select>
            </li>
            <span className="editItem-error-message">{errors.proveedor}</span>
          </div>

          <div className="editItem-ind-info">
            <label htmlFor="class">Clase:</label>
            <li className="editItem-list-group-item">
              <input
                type="text"
                id="class"
                name="class"
                value={inputs.class}
                placeholder={currentItem?.class}
                onChange={handleInputChange}
                className="editItem-input_text"
              />
            </li>
            <span className="editItem-error-message">{errors.class}</span>
          </div>
          <div className="editItem-ind-info">
            <label htmlFor="consumptionUnit">Unidad de consumo:</label>
            <li className="editItem-list-group-item">
              <select
                id="consumptionUnit"
                name="consumptionUnit"
                value={inputs.consumptionUnit}
                onChange={handleInputChange}
                className="editItem-input_text"
              >
                <option value={"null"}>No corresponde consumo</option>
                {units &&
                  units.map((u) => (
                    <option key={u} value={u}>
                      {u}
                    </option>
                  ))}
              </select>
            </li>
          </div>

          <div className="editItem-ind-info">
            <label htmlFor="costUnit">Unidad de costo:</label>
            <li className="editItem-list-group-item">
              <select
                id="costUnit"
                name="costUnit"
                value={inputs.costUnit}
                onChange={handleInputChange}
                className="editItem-input_text"
              >
                <option value={"null"}>Sin costo</option>
                <option value={"N/A"}>N/A</option>
                <option value={"AR"}>AR</option>
                <option value={"USD"}>USD</option>
              </select>
            </li>
          </div>

          <button
            type="submit"
            className="editItem-btnPass"
            onClick={handleSubmit}
          >
            Editar
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditItemBill;
